import Head from 'next/head'
import Script from 'next/script';
import { FC } from 'react';
import { webUrl, domain, blockGoogleSearch } from 'models/conent';
import { CONSENT_COOKIE, CONSENT_VERSION } from '@components/CookieConsent';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { getPathFromUrl } from 'utils/url';

interface IHeader {
    content: string;
    title: string;
    image: string;
    url?: string;
}

interface IProps {
    content?: IHeader;
}
const Header: FC<IProps> = (props) => {
    const router = useRouter();
    const desc = 'ผู้ให้บริการ Full-service Digital Transformation เปลี่ยนการทำงานจากกระดาษสู่ดิจิทัล ผู้เชี่ยวชาญด้าน Digital Signature ที่กว่า 100 บริษัทที่ไว้วางใจ';
    const image = webUrl + '/images/CodiumOgImage.jpg';
    const title = 'CODIUM เปลี่ยนการทำงานจากกระดาษสู่ดิจิทัล';
    const pageUrl = webUrl + getPathFromUrl(router.asPath);

    return <>
        <Head>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <link rel="icon" type="image/png" href="/images/CODIUM.png" />
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
            <meta charSet="utf-8" />
            <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="facebook-domain-verification" content="tnaexja89roj9zcv6qjoz6h5n6naxx" />
            <meta name="google-site-verification" content="Jp479_uwiyZdZ2wLqR4LPesF7e9zfbCdOEWZpzpXvIU" />
        </Head>

        <NextSeo
            noindex={blockGoogleSearch}
            title={props.content?.title ? props.content?.title : title}
            description={props.content?.content ? props.content?.content : desc}
            canonical={pageUrl}
            openGraph={{
                type: 'website',
                title: props.content?.title ? props.content?.title : title,
                description: props.content?.content ? props.content?.content : desc,
                url: pageUrl,
                site_name: domain,
                images: [
                    {
                        url: `${props.content?.image ? `${props.content.image}` : image}`
                    }
                ]
            }}
            twitter={{
                cardType: 'summary_large_image',
                site: '@CodiumOfficial',
                handle: '@CodiumOfficial'
            }}
        />
        
        <div className="">
            <Script id="smoothscroll.min.js" src="https://unpkg.com/smoothscroll-polyfill/dist/smoothscroll.min.js"></Script>
            <Script id="smoothscroll-anchor-polyfill" src="https://unpkg.com/smoothscroll-anchor-polyfill"></Script>

            {/* Google Tag Manager */}
            <Script
                id="gtm-script"
                dangerouslySetInnerHTML={{
                    // Consent Mode defaults run in the same script, ahead of
                    // GTM, so no tag can fire before them. A returning
                    // visitor's stored choice is applied straight away; it
                    // mirrors readConsent() in components/CookieConsent.
                    __html: `window.dataLayer=window.dataLayer||[];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('consent','default',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied',wait_for_update:500});
                        try{var m=document.cookie.match(/(?:^|; )${CONSENT_COOKIE}=([^;]*)/);
                        var c=m&&JSON.parse(decodeURIComponent(m[1]));
                        if(c&&c.v===${CONSENT_VERSION}&&typeof c.analytics==='boolean'&&typeof c.marketing==='boolean'){
                        var a=c.marketing?'granted':'denied';
                        gtag('consent','update',{analytics_storage:c.analytics?'granted':'denied',ad_storage:a,ad_user_data:a,ad_personalization:a});}}catch(e){}
                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','GTM-N3QX6HR');`
                }}
            />
            <noscript
                dangerouslySetInnerHTML={{
                    __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N3QX6HR"
                        height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
                }}
            ></noscript>

            {/* End Google Tag Manager (noscript) */}


            <Script
              id="schema-script"
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify({
                      "@context": "https://schema.org",
                      "@type": "Organization",
                      address: {
                          "@type": "PostalAddress",
                          "addressCountry": "Thailand",
                          "addressRegion": "Bangkok",
                          "postalCode": "10330",
                          "streetAddress": "Rama 1 Road, Wang Mai",
                          "address": "Siam@Siam Hotel Building, 7th Floor 865 Rama 1 Road, Wang Mai, Patumwan Bangkok 10330, Thailand"
                      },
                      name: "Codium",
                      telephone: "02 612 3838",
                      brand: "E-Memo, E-Digital Signature, E-Tax Invoice, E-Receipt"
                  })
              }}
            />

           

            
        </div>
    </>
}
export default Header;
